import { render, staticRenderFns } from "./registerParcelStep2.vue?vue&type=template&id=061a191a&scoped=true&"
import script from "./registerParcelStep2.vue?vue&type=script&lang=js&"
export * from "./registerParcelStep2.vue?vue&type=script&lang=js&"
import style0 from "./registerParcelStep2.vue?vue&type=style&index=0&id=061a191a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a191a",
  null
  
)

export default component.exports